<template>
  <div>
    <ratings-overview
      :count="totalReviewCount"
      :average="starAggregate"
      :distributionData="distributionData"
      :showSitterView="profileBelongsToViewer"
    />
    <poppins-button :value="buttonValue" variant="outlined" size="medium" class="w-full mt-16" :href="buttonHref" />
    <reviews-list
      :reviews="reviews"
      :totalReviewCount="totalReviewCount"
      :showReplies="true"
      :revieweeDisplayName="profileAccountData.displayName"
      :isOwner="profileBelongsToViewer"
      :fullWidthBtn="true"
      class="mt-24"
      @view-more-reviews="$emit('view-more-reviews')"
    />
  </div>
</template>

<script lang="ts">
import RatingsOverview from '@/components/ratings_overview/RatingsOverview.vue';
import ReviewsList from '@/components/reviews_list/ReviewsList.vue';
import PoppinsButton from '@/components/button/Button.vue';

interface Review {
  node: {
    reviewerShortName: string;
    stars: string;
    at: string;
    publicFeedback: string;
  };
}

interface DistributionData {
  count: number;
  percent: number;
  stars: number;
}

export default {
  name: 'ProfileReviews',
  components: {
    RatingsOverview,
    ReviewsList,
    PoppinsButton,
  },
  props: {
    reviewsData: {
      type: Object,
      default: () => ({}),
    },
    profileAccountData: {
      type: Object,
      default: () => ({}),
    },
    profileBelongsToViewer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviews(): Array<Review> {
      return this.reviewsData?.edges || [];
    },
    totalReviewCount(): number {
      return this.reviewsData?.totalReviewCount || 0;
    },
    starAggregate(): number {
      return this.reviewsData?.starAggregate || 0;
    },
    distributionData(): Array<DistributionData> {
      return this.reviewsData?.ratingsDistribution || [];
    },
    buttonValue(): string {
      return this.profileBelongsToViewer ? 'Request reviews' : 'Leave a review';
    },
    buttonHref(): string {
      const encodedUri = encodeURIComponent(window.location.pathname);
      return this.profileBelongsToViewer
        ? `/provider/reviews/request?returnPath=${encodedUri}`
        : `/ratings/sitters/${this.profileAccountData.id}/new?return-path=${encodedUri}`;
    },
  },
};
</script>
